import { joinClassNames } from "@common/lib/util"
import Svg from "@common/svg"
import { TableRowProps } from "@common/table/types"
import React from "react"

const ExpandButton = ({ row, table }: Omit<TableRowProps, "rowIndex">) => {
  const {
    options: { renderRowExpandDetails },
  } = table
  const canExpand = row.getCanExpand()
  const isExpanded = row.getIsExpanded()

  const handleClick = (e: any) => {
    e.stopPropagation()
    row.toggleExpanded()
  }

  return (
    <button
      onClick={handleClick}
      disabled={!canExpand && !renderRowExpandDetails}
      className="disabled:opacity-30 disabled:cursor-not-allowed cursor-pointer"
    >
      <Svg
        name="arrow-right-short"
        classes={joinClassNames(
          "w-4 h-4 mr-1 text-gray-600 transform  duration-150 ease-in-out  ",
          !canExpand && !renderRowExpandDetails
            ? "rotate-0"
            : isExpanded
            ? "rotate-90"
            : "rotate-0"
        )}
      />
    </button>
  )
}

export default ExpandButton
